<p-dialog [(visible)]="displayDialog" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '75vw' }" [closable]="false">
	<ng-template pTemplate="header">
		<div class="display-6">
			<fa-icon [icon]="['far', 'user-crown']" class="me-4" size="lg"></fa-icon>
			{{ user.firstName }} {{ user.lastName }}
		</div>
	</ng-template>
	<p-tabView [(activeIndex)]="activeTabIndex">
		<p-tabPanel>
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'user']" class="me-4" size="lg"></fa-icon>
				Profile
			</ng-template>
			<app-user-profile
				#userProfileComponent
				[(changesToSave)]="changesToSave"
				[(user)]="user"
				[dealerList]="dealerList"
				(dealerSelectedChange)="venueListFilterByDealer($event)"
				[currentUserProfileEdit]="currentUserProfileEdit"
			></app-user-profile>
		</p-tabPanel>
		<p-tabPanel *ngIf="!currentUserProfileEdit">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'store']" class="me-4" size="lg"></fa-icon>
				Venue Access
			</ng-template>
			<app-user-venue-setup
				#userVenueSetupComponent
				[(changesToSave)]="changesToSave"
				[(user)]="user"
				[dealerList]="dealerList"
				[venueSelectionsAvailable]="venueSelectionsAvailable"
			></app-user-venue-setup>
		</p-tabPanel>
		<p-tabPanel>
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'bars']" class="me-4" size="lg"></fa-icon>
				Menu Preferences
			</ng-template>
			<app-user-menu-setup #userMenuSetupComponent [(changesToSave)]="changesToSave" [(user)]="user"></app-user-menu-setup>
		</p-tabPanel>
	</p-tabView>

	<ng-template pTemplate="footer">
		<p-button
			*ngIf="userService.userSubscription.value.role >= 5"
			pRipple
			styleClass="p-button-raised p-button-warning m-2"
			(click)="impersonateUserPrompt = true"
		>
			<ng-template pTemplate="content">
				<div class="d-flex justify-content-center">
					<fa-icon [icon]="['far', 'user-alien']" size="lg" class="ms-1 me-2"></fa-icon>
					Impersonate User
				</div>
			</ng-template>
		</p-button>
		<app-record-control-footer
			[hideDelete]="currentUserProfileEdit"
			(onCancelChange)="onCloseChange.emit(false)"
			(onSaveChange)="onSave()"
			(onDeleteChange)="onDelete()"
			[saveDisabled]="!changesToSave"
		></app-record-control-footer>
	</ng-template>
</p-dialog>

<p-dialog [(visible)]="impersonateUserPrompt" [style]="{ width: '20vw' }">
	<div class="d-flex w-100 flex-column">
		<div class="mx-auto display-8 text-center">Please enter your password to continue</div>
		<div>
			<span class="p-float-label mt-4">
				<input
					pInputText
					#impersonateUserPasswordPrompt
					name="impersonateUserPasswordPrompt"
					type="password"
					[(ngModel)]="impersonateUserPassword"
					class="w-100"
				/>
				<label for="impersonateUserPasswordPrompt">Your password</label>
			</span>
		</div>
		<div>
			<p-button pRipple styleClass="p-button-raised p-button-primary m-2" (click)="impersonateUserPrompt = false; impersonateUser()">
				<ng-template pTemplate="content">
					<div class="d-flex justify-content-center">
						<fa-icon [icon]="['far', 'arrow-right-to-bracket']" size="lg" class="ms-1 me-2"></fa-icon>
						Login
					</div>
				</ng-template>
			</p-button>
		</div>
	</div>
</p-dialog>
